module.exports = __webpack_public_path__ + "static/media/recommendation-icon.a0461f12.svg";